import React, {useState, useEffect} from 'react'
import NACE from "assets/data/NACE.json";

import t from 'helpers/I18n'
import InputField from "../../base-components/base-input";

import PropTypes from 'prop-types'
import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
import { useHistory } from 'react-router-dom';
import StepsLoader from "../steps-loader";
import { HiOutlineLightBulb } from 'react-icons/hi'
import { GoChevronLeft } from 'react-icons/go'
import BottomSheet from '../../modals/bottom-sheet';
import StepFooterAction from "../../base-components/step-footer-action";

const ChildListDisplay = ({ childList, getChildCode, searchTerm, getParentCode }) => {
  const LANG = localStorage.getItem("language")
  
function boldString(str, find) {
  var reg = new RegExp('('+find+')', 'gi');
  return str.replace(reg, '<b>$1</b>');
}

  return (
    <div className={"nace-list "}>      
      {childList.map(child => <div className={"nace-option"} onClick={() => {
        const code = child.CODE
        const name = child[`NAME_${LANG}`]
        console.log(code, name)
        getChildCode(code, name)
        getParentCode(code, name)
      } }>
        <span dangerouslySetInnerHTML={{__html: `${child.CODE.replace(searchTerm, searchTerm.bold())} - `}} />
        <span dangerouslySetInnerHTML={{__html: boldString(child[`NAME_${LANG}`], searchTerm)}} />
      </div>)}
     </div>
  )
}

const Nace = ({ _step_service, step_ID, setDataToContext, getDataFromContext, step_URL, next_step }) => {
  const LANG = localStorage.getItem("language")
  
  const data = getDataFromContext(step_ID)

  console.log("data", data)

  const name = "enterprise_activity_code"
  const className = "country-selector"

  const _className = "textField " + name
  const error_className = "hello-input "
  const [inputData, setInputData] = useState({ ...data })
  const [naceCode, setNaceCode] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [childList, setChildList] = useState(NACE.filter(nace => nace.CODE_PARENT === "-"))
  const [dynamicSubTitle, setDynamicSubTitle] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [showSearchBar, setShowSearchBar] = useState(true)
  const [selectionTree, setSelectionTree] = useState(data?.internal_nace_selectionTree ? data.internal_nace_selectionTree.split(",") : [])
  const [selectionNameTree, setSelectionNameTree] = useState([])
  const [finalTree, setFinalTree] = useState(data?.internal_nace_selectionTree ? data.internal_nace_selectionTree.split(",") : [])
  const [dynamicTitle, setDynamicTitle] = useState('')
  const [nextTick, setNextTick] = useState(false)
  const treeCode = []

  useEffect(() => {
    console.log("data = ", data)
    setIsValid(inputData[name])
  }, [])

  useEffect(() => {
    if (nextTick) _step_service({ step_ID, setIsLoading, next_step })
  }, [nextTick])

  useEffect(() => {
        if (window.PageBus) {
          window.PageBus.publish("analyticsServices", {
            pageID: "onboarding",
            stepSeq: "3",
            stepName: "pro info:what is your professional activity",
            flowType: "sales",
            flowName: "onboarding",
            productName: "onboarding",
            trackMethod: "flow"
            }
          );
        }
  }, [])

  const getNace = value => NACE.filter((nace) => nace[`NAME_${LANG}`].toLowerCase().includes(value.toLowerCase()) || nace.CODE.startsWith(value))

  const searchHandle = (e) => {
    const searchTerm = e.target.value
    const filterChildList = (list) => {
      // return list.filter((listItem, index, self) =>
      //   index !== self.findIndex((t) => (
      //     t[`NAME_${LANG}`] === listItem[`NAME_${LANG}`]
      //   ))
      // )

      return list.filter((listItem, index, self) =>
        index !== self.findIndex((t) => (
          t[`NAME_${LANG}`] === listItem[`NAME_${LANG}`]
        ))
      )
    }
    setSearchTerm(searchTerm)
    // setChildList(filterChildList(getNace(searchTerm)))
    setChildList(getNace(searchTerm))
  }

  const action = () => {
    setDataToContext(step_ID, step_URL, "enterprise_activity_code", finalTree.join(","))
    setDataToContext(step_ID, step_URL, 'internal_nace_selectionTree', finalTree.join(","))
    setDataToContext(step_ID, step_URL, 'internal_nace_name', inputData["internal_nace_name"])

    console.log(finalTree.join(","), finalTree.join(","), inputData["internal_nace_name"])
    setNextTick(true)
  }

  const close = () => {
    if (data?.internal_nace_selectionTree) {
      setSelectionTree(data?.internal_nace_selectionTree)
    }
    setShowModal(false)
    setChildList(NACE.filter(nace => nace.CODE_PARENT === "-"))
    setShowSearchBar(true)
  }

  const getTreeCode = (code) => {
    treeCode.push(code)
    const parentCode = NACE.find(nace => nace.CODE === code && nace.CODE.startsWith(code)).CODE_PARENT
    console.log(code, treeCode, parentCode)

    if (parentCode !== "-" && /[0-9]/.test(parentCode) ) {
      getTreeCode(parentCode)
    } 
      return treeCode
    
  }

  const naceBackNav = () => {
    console.log("selectionTree => ", selectionTree)
    const index = selectionTree.length - 1


    if (index > 0) {
      console.log(selectionTree[index])
      setChildList(NACE.filter(nace => nace.CODE_PARENT === selectionTree[index - 1]))
      const newSelectionTree = selectionTree
      newSelectionTree.pop()
      setSelectionTree(newSelectionTree)
      getDynamicTitle(selectionTree[index - 1], selectionNameTree[index-1])
    } else {
      setChildList(NACE.filter(nace => nace.CODE_PARENT === "-"))
      setSelectionTree([])

      setShowSearchBar(true)
      setDynamicTitle('')
    }
  }

  const getChildCode = (code, name) => {
    selectionTree.push(code)
    selectionNameTree.push(name)

    setSelectionNameTree(selectionNameTree)
    setSelectionTree(selectionTree)
    setShowSearchBar(false)
    if (name !== undefined) setDynamicSubTitle(getDynamicTitle(code, name))
    
    if (code.length === 5) {
      console.log('ici')
      setInputData({
        ...inputData,
        "internal_nace_name" : `${code} - ${NACE.find(nace => nace.CODE === code)[`NAME_${LANG}`]}`
      })
      setNaceCode(code)
      setShowModal(false)
      setIsValid(true)

    } else {

      if (NACE.filter(nace => code === nace.CODE_PARENT).length === 1 && !isNaN(code)) {
        getChildCode(code + "0")
      } else {
        if (NACE.filter(nace => nace.CODE_PARENT === code).length > 0) {
          setChildList(NACE.filter(nace => nace.CODE_PARENT === code ))
        } else {
          setInputData({
            ...inputData,
            "internal_nace_name" : `${code} - ${NACE.find(nace => nace.CODE === code)[`NAME_${LANG}`]}`
          })
          setNaceCode(code)
          setShowModal(false)
          setIsValid(true)
        }
      }
    }
  }

  const getParentCode = (code, name) => {
    const tree =[code]
    const getParent = (code) => {
      const _parent = NACE.filter(nace => nace.CODE === code)[0].CODE_PARENT
      
      if (_parent !== "-") {
        tree.push(_parent)
        getParent(_parent)
      } 

    }

    getParent(code)
    setFinalTree(tree.reverse().concat(selectionTree.filter(item => tree.indexOf(item) < 0)) )
  }

  const getDynamicTitle = (code, internal_nace_name) => {
    // const name = NACE.find(nace => nace.CODE === code )[`NAME_${LANG}`]
    const name = internal_nace_name 
    const dynamicTitle = t('pro_infos.pro_info_what_is_your_professional_activity.dynamyc_title')
    console.log(dynamicTitle.replace('###var_nace_sector###', name.bold()))
    setDynamicTitle(dynamicTitle.replace('###var_nace_sector###', name.bold()))
  }

  const openModal = () => {
    setShowModal(true)
    if (data?.internal_nace_selectionTree) {
      setSelectionTree([])
    }
  }

  return (
    <StepsLoader step_ID={step_ID} loading={isLoading}>
        <form >
            <BaseParagraph>
              <h3>{t('pro_infos.pro_info_what_is_your_professional_activity.title')}</h3>
            </BaseParagraph>
    
            <div className={_className}>
              <label className={error_className}>
                  <input
                      placeholder=" "
                      type={"text"}
                      name={name}
                      id={name}
                      value={inputData["internal_nace_name"]}
                      onClick={openModal}
                      autoComplete="off"
                  />
                  <span>{t('pro_infos.pro_info_what_is_your_professional_activity.label')}</span>
              </label>
          </div>
        </form>
      
        <StepFooterAction caption={t('general.continue')} action={action} disabled={!isValid} />
        {showModal && childList && 
          <BottomSheet title={""} close={close}>
             {!showSearchBar && <div onClick={naceBackNav} className="nace-back"> <GoChevronLeft /> {t('general.back')} </div> } 
              <BaseParagraph>
                  <h4 dangerouslySetInnerHTML={{__html: dynamicTitle}} /> 
              </BaseParagraph>
              {showSearchBar && 
              <div className={className + '__search'}>
                  <input
                    placeholder={t('pro_infos.pro_info_what_is_your_professional_activity.label')}
                    type={"text"}
                    name={name}
                    id={name}
                    value={searchTerm}
                    onChange={searchHandle}
                    autoComplete="off"
                    autoFocus={true}
                  />
                  <div className={"search-icon fonticons-search"}></div>
              </div>
              }
              <ChildListDisplay childList={childList} getChildCode={getChildCode} searchTerm={searchTerm} getParentCode={getParentCode} />
          </BottomSheet>
        }
    </StepsLoader>
  )
}

export default Nace
